import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './utils/global';
import { router } from './router/router';
import message from './services/message';
import directive from './directives';
import queryParams from './services/pageQuery.service';
import eventBus from './services/eventBus.service';
import promiseFinally from 'promise.prototype.finally';
import util from './utils/util';
import 'abortcontroller-polyfill';
// 开发环境使用-提测后要注释掉
const isPord = process.env.NODE_ENV === 'production';
promiseFinally.shim();
queryParams.init(window.location.href);
if (queryParams._isDebug || !isPord) {
  import('vconsole').then((VConsole) => {
    new VConsole.default();
  });
}
message.listen();
Vue.use(directive);
Vue.config.productionTip = false;
Vue.prototype.$queryParams = queryParams;
Vue.prototype.$bus = eventBus;

window.___VUE___ = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#container');

window.h5GoBack = function () {
  console.log('h5GoBack');
};

setTimeout(() => {
  util.loadScript({
    id: 'formmisplacefixall_wx_v11',
    cross: true,
    src: 'https://s.autoimg.cn/dealer/m/publicjs/formmisplacefixall_wx_v11.js',
  });
  if (!window.$) {
    util.loadScript({
      id: 'zepto',
      cross: true,
      async: true,
      src: 'https://x.autoimg.cn/dealer/dealerm/minisite/js/zepto-1.2.2.min.js',
    });
  }
}, 100);
